// @ts-ignore
import { DataGridTypes } from 'devextreme-react/data-grid';
import dayjs from 'dayjs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/common/export/excel';
import { Workbook } from 'exceljs';
import { formatDateTime } from 'utils/helpers';

export const csvSaver = (
  e: DataGridTypes.ExportingEvent,
  title: string,
) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main');

  exportDataGrid({
    component: e.component,
    worksheet,
    customizeCell: ({ gridCell, excelCell }) => {
      if (gridCell) {
        if (gridCell.column?.dataType === 'date' && gridCell.value) {
          excelCell.value = formatDateTime(gridCell.value);
        }
      }
    },
  }).then(() => {
    workbook.csv.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], {
          type: 'text/csv;charset=utf-8',
        }),
        `${title + dayjs().format('DDMMYYYY')}.csv`
      );
    });
  });
};
